import { appConfigContext } from 'nexchange-service/appServiceConfig'

const isTestingWalletAddress = (walletAddress: string): boolean =>
    appConfigContext.getAppConfig().TEST_ORDERS.TEST_WALLET_ADDRESSES.includes(walletAddress)

const isTestingPairAmount = ({
    fromCode,
    toCode,
    fromAmount,
}: {
    fromCode: string
    toCode: string
    fromAmount: number
}): boolean => {
    if (appConfigContext.getAppConfig().TEST_ORDERS.TEST_COIN_CODES.includes(toCode)) {
        if (fromCode === 'RUB' && fromAmount < 1000) {
            return true
        }

        if (fromAmount < 100) return true
    }
    return false
}

const getIsTestingOrder = ({
    fromCode,
    toCode,
    fromAmount,
    walletAddress,
}: {
    fromCode: string
    toCode: string
    fromAmount: number
    walletAddress: string
}): boolean => {
    if (isTestingWalletAddress(walletAddress)) return true
    if (isTestingPairAmount({ fromCode, toCode, fromAmount })) return true
    return false
}

export { getIsTestingOrder }
